import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface TipoZonaPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface TipoZona {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface TipoZonaResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class TipoZonaService {
  private readonly apiUrl = `${environment.apiUrl}/api/tipo_zona`;

  constructor(private http: HttpClient) {}

  // Obtener todos
  getAll(): Observable<TipoZona[]> {
    return this.http.get<TipoZona[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener por ID
  getById(id: number): Observable<TipoZona> {
    return this.http.get<TipoZona>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear
  create(
    payload: TipoZonaPayload
  ): Observable<TipoZonaResponse> {
    return this.http.post<TipoZonaResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar
  update(
    id: number,
    payload: Partial<TipoZonaPayload>
  ): Observable<TipoZonaResponse> {
    return this.http.put<TipoZonaResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar
  inactivar(id: number): Observable<TipoZonaResponse> {
    return this.http.put<TipoZonaResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar
  activar(id: number): Observable<TipoZonaResponse> {
    return this.http.put<TipoZonaResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}